module.exports = __webpack_public_path__ + "img/1.59810b7d.png";